<template>
  <a-modal
    v-model="visible"
    :title="modalTitle"
    :maskClosable="false"
    :closable="!formLoading"
    :okText="$t('com_btn_save')"
    :width="600"
    @ok="formSubmit"
    @cancel="formReset"
    :confirmLoading="formLoading"
    :cancelButtonProps="{
      props: {
        disabled: formLoading,
      },
    }"
    destroyOnClose
    centered
  >
    <a-form-model
      :model="form"
      :rules="rules"
      ref="configUpdate"
      :label-col="{ span: 7 }"
      :wrapper-col="{ span: 14 }"
    >
      <!-- 控制名称 -->
      <a-form-model-item :label="$t('deviceModel_form_control_name')" prop="cmdName">
        <a-input
          v-model="form.cmdName"
          :placeholder="$t('deviceModel_form_control_name_placeholder')"
          allowClear
          @input="formInput"
          style="width:100%;"
        />
      </a-form-model-item>

      <!-- 控制类型 -->
      <!-- 控制命令编码，同一个设备模型下不可重复 -->
      <a-form-model-item
        :label="$t('deviceModel_form_control_type')"
        prop="protoEventType"
        :help="$t('deviceModel_form_control_type_help')"
      >
        <a-input-number
          v-model="form.protoEventType"
          :placeholder="$t('deviceModel_form_control_type_placeholder')"
          allowClear
          @input="formInput"
          style="width:100%;"
        />
      </a-form-model-item>

      <!-- 控制级别 -->
      <a-form-model-item :label="$t('deviceModel_form_control_level')" prop="ctrlLevel">
        <a-input-number
          v-model="form.ctrlLevel"
          :placeholder="$t('deviceModel_form_control_level_placeholder')"
          allowClear
          @input="formInput"
          style="width:100%;"
        />
      </a-form-model-item>

      <!-- 显示顺序 -->
      <a-form-model-item
        :label="$t('deviceModel_form_display_priority')"
        prop="displayPrio"
        help="Only numerical values are allowed"
      >
        <a-input-number
          v-model="form.displayPrio"
          :placeholder="$t('deviceModel_form_display_priority_placeholder')"
          allowClear
          @input="formInput"
          style="width:100%;"
        />
      </a-form-model-item>

      <!-- 参数1 -->
      <a-form-model-item
        :label="$t('deviceModel_form_control_param1')"
        prop="param1"
        :help="$t('deviceModel_form_control_param_help')"
      >
        <a-input
          v-model="form.param1"
          :placeholder="$t('deviceModel_form_control_param1_placeholder')"
          allowClear
          @input="formInput"
          style="width:100%;"
        />
      </a-form-model-item>

      <!-- 参数2 -->
      <a-form-model-item
        :label="$t('deviceModel_form_control_param2')"
        prop="param2"
        :help="$t('deviceModel_form_control_param_help')"
      >
        <a-input
          v-model="form.param2"
          :placeholder="$t('deviceModel_form_control_param2_placeholder')"
          allowClear
          @input="formInput"
          style="width:100%;"
        />
      </a-form-model-item>
    </a-form-model>
    <!-- 错误描述 -->
    <div class="form-error-text">
      <Icon type="error" v-if="formError" />
      <p>{{ formError }}</p>
    </div>
  </a-modal>
</template>
<script>
import * as API from '@/api/system/model';
import { mapGetters } from 'vuex';

export default {
  props: {
    updateType: {
      type: String,
      default: 'config',
    },
    groupList: {
      type: Array,
      default: () => [],
    },

    callback: {
      type: Function,
      default: () => {},
    },

    modelList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modelInfo: null,
      currentInfo: null,

      currentItemType: null,

      // 配置列表（根据分组ID暂存）
      configLoading: false,
      configList: {
        // 1:[{name:'confit item1'}]
      },

      // 当前组别配置列表
      groupConfigList: [],

      // 新增
      visible: false,
      rules: {
        cmdName: [
          {
            required: true,
            message: this.$t('deviceModel_form_control_name_placeholder'),
            trigger: 'change',
          },
        ],
        protoEventType: [
          {
            required: true,
            message: this.$t('deviceModel_form_control_type_placeholder'),
            trigger: 'change',
          },
          // {
          //   validator: (rule, value, callback) => {
          //     // 下列validValues已经占用，请使用其他值
          //     const validValues = [1, 2, 3, 4, 5, 6, 7, 8, 9];
          //     if (validValues.includes(value)) {
          //       callback(
          //         new Error(
          //           validValues.join(',') + ' has already been used, please use a different name.'
          //         )
          //       );
          //     } else {
          //       callback();
          //     }
          //   },
          //   trigger: 'blur',
          // },
        ],
        ctrlLevel: [
          {
            required: true,
            message: this.$t('deviceModel_form_control_level_placeholder'),
            trigger: 'change',
          },
          {
            validator: (rule, value, callback) => {
              if (value < this.userInfo.role.paramWriteLevel) {
                callback(
                  `${this.$t('deviceModel_form_data_write_tips')} ${
                    this.userInfo.role.paramWriteLevel
                  }`
                );
              }
              callback();
            },
            trigger: 'change',
          },
        ],
      },

      // 表单
      form: {
        cmdName: undefined,
        protoEventType: undefined,
        ctrlLevel: undefined,
        displayPrio: undefined,
        param1: undefined,
        param2: undefined,
      },

      formError: '',
      formIsEdit: '',
      formLoading: false,
      formFork: false,

      // 上传图片
      fileList: [],
      uploading: false,
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    modalTitle() {
      if (this.formIsEdit) {
        return this.$t('deviceMode_control_edit_title');
      } else {
        if (this.formFork) {
          return this.$t('deviceMode_control_fork_title');
        } else {
          return this.$t('deviceMode_control_add_title');
        }
      }
    },
  },

  methods: {
    // 更新列表
    updateList() {
      // 更新列表
      this.callback(this.updateType);
    },

    // 显示
    show(model, currentItem, fork) {
      this.visible = true;
      this.modelInfo = model;
      this.currentInfo = currentItem;
      this.formIsEdit = currentItem && !fork ? true : false;
      this.formError = '';
      this.formFork = fork;

      // focus name
      this.$nextTick(() => {
        this.formReset();

        if (this.formIsEdit || this.formFork) {
          this.form = {
            cmdName: currentItem.cmdName,
            protoEventType: currentItem.protoEventType,
            ctrlLevel: currentItem.ctrlLevel,
            displayPrio: currentItem.displayPrio,
            param1: currentItem.param1,
            param2: currentItem.param2,
          };
        }
      });
    },

    // 提交
    formSubmit() {
      this.$refs.configUpdate.validate(valid => {
        if (valid) {
          this.formLoading = true;

          const params = {
            ...this.form,
          };
          if (this.formIsEdit) {
            params.id = this.currentInfo.id;

            // 编辑
            API.DeviceModelControlEdit(params)
              .then(res => {
                if (res.code === 0) {
                  this.visible = false;
                  this.formReset();
                  // 更新列表
                  this.updateList();
                } else {
                  this.formError = res.message;
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          } else {
            params.devModelId = this.modelInfo.devModelId;
            // 添加
            API.DeviceModelControlAdd(params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_msg_add_success'));
                  this.visible = false;
                  this.formReset();
                  // 更新列表
                  this.updateList();
                } else {
                  this.formError = res.message;
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // error reset
    formInput() {
      this.formError = '';
    },
    // add form reset
    formReset() {
      this.$refs.configUpdate.resetFields();

      Object.keys(this.form).forEach(key => {
        this.form[key] = undefined;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.form-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;
  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}

::v-deep .ant-form-item {
  margin-bottom: 10px;
}
</style>
